import { z } from 'zod'

export const COACHING_SHELL_REPORT_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellReportResponseSchema = z.unknown()
export type CoachingShellReportResponse = z.infer<typeof coachingShellReportResponseSchema>

/** Optional download selector: reportId picks one scoped report; absent falls back to newest. */
export const coachingShellReportDownloadQuerySchema = z
  .object({
    reportId: z.union([z.string(), z.number()]).optional(),
  })
  .passthrough()
export type CoachingShellReportDownloadQuery = z.infer<typeof coachingShellReportDownloadQuerySchema>
